import { NotifyHelper } from "../../../helpers/toast";
import { eKeHoachNamActionsObj } from "../../action-types/category/IKeHoachNamActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const keHoachNamActions = {
  ...generateActions(eKeHoachNamActionsObj, "KE_HOACH_NAM"),
};
